var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgElectronicOnestep = function SvgElectronicOnestep(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#A266A2",
    rx: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M10 2 9 7h3l-6 7 1-5H4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.272 5.976a.384.384 0 0 1-.384.384H1.584a.384.384 0 0 1 0-.768h.768V2.086l-.555.37a.384.384 0 1 1-.426-.64l1.152-.767a.383.383 0 0 1 .597.32v4.223h.768c.212 0 .384.172.384.384"
  })));
};
export default SvgElectronicOnestep;